import e from "./ghl-ui.es1566.js";
var a = function() {
  var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}();
function t(r) {
  return !!a && a in r;
}
export {
  t as default
};
